module.exports = __webpack_public_path__ + "static/media/clinical_location_icon.ef0c2c04.svg";